<script>
export default {
  name: "advertisementOne"
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #2D2D2D">
    <el-col :span="24" style="display: flex; justify-content: center">
      <img
        loading="lazy"
        src="../../assets/advertisement-1.png"
        style="width: 100%; height: 126px; object-fit: cover"
      />
    </el-col>
  </el-row>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/search/advertisementOne.vue